import { IUserAwards } from '../../../../../../store/admin/roundFormatAwards/store';

export const getUserAwards = (
  userId: number,
  userAwards: IUserAwards,
  awardsToUpdate: IUserAwards
) => {
  return awardsToUpdate[userId]
    ? awardsToUpdate[userId]
    : userAwards[userId]
    ? userAwards[userId]
    : null;
};
